import { useState } from 'react'
import { ErrorVariosTenants, login, type Sesion } from '../datos/sesion.js'

/**
 * El login es, junto con el sincronizador, la única parte de la app que toca la
 * red. No hay alternativa: ocurre antes de que exista base local que leer.
 */
export function Login({ onEntrar }: { onEntrar: (s: Sesion) => void }) {
  const [email, setEmail] = useState('')
  const [clave, setClave] = useState('')
  const [tenants, setTenants] = useState<{ id: string; nombre: string }[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [cargando, setCargando] = useState(false)

  async function entrar(tenantId?: string) {
    setCargando(true)
    setError(null)
    try {
      onEntrar(await login(email, clave, tenantId))
    } catch (e) {
      if (e instanceof ErrorVariosTenants) {
        // Varias clínicas: elige el usuario, no nosotros.
        setTenants(e.tenants)
      } else {
        setError(e instanceof Error ? e.message : 'No pudimos iniciar sesión')
      }
    } finally {
      setCargando(false)
    }
  }

  return (
    <main className="flex min-h-dvh items-center justify-center superficie-base p-6">
      <form
        onSubmit={(ev) => {
          ev.preventDefault()
          void entrar()
        }}
        className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-6 shadow-sm"
      >
        <h1 className="text-xl font-semibold text-teal-800">practiClinic</h1>
        <p className="mt-1 text-sm text-slate-500">Ingresá para ver la agenda</p>

        {tenants ? (
          <div className="mt-6">
            <p className="text-sm text-slate-700">¿En qué clínica vas a trabajar?</p>
            <ul className="mt-2 space-y-2">
              {tenants.map((t) => (
                <li key={t.id}>
                  <button
                    type="button"
                    onClick={() => void entrar(t.id)}
                    className="min-h-11 w-full rounded-lg border border-slate-300 px-3 text-left text-sm hover:bg-slate-50"
                  >
                    {t.nombre}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <>
            <label className="mt-6 block text-sm text-slate-700">
              Correo
              <input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                className="mt-1 min-h-11 w-full rounded-lg border border-slate-300 px-3"
                required
              />
            </label>

            <label className="mt-3 block text-sm text-slate-700">
              Contraseña
              <input
                type="password"
                autoComplete="current-password"
                value={clave}
                onChange={(ev) => setClave(ev.target.value)}
                className="mt-1 min-h-11 w-full rounded-lg border border-slate-300 px-3"
                required
              />
            </label>

            {error && (
              <p role="alert" className="mt-3 rounded-lg bg-rose-50 p-2 text-sm text-rose-800">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={cargando}
              className="mt-5 min-h-11 w-full rounded-lg bg-teal-700 text-sm font-medium text-white disabled:opacity-60"
            >
              {cargando ? 'Entrando…' : 'Entrar'}
            </button>
          </>
        )}
      </form>
    </main>
  )
}
